/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_OverlineInputs */

const en_mk_sec_pg_ledger_overline = /** @type {(inputs: Mk_Sec_Pg_Ledger_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The open ledger`)
};

const id_mk_sec_pg_ledger_overline = /** @type {(inputs: Mk_Sec_Pg_Ledger_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar terbuka`)
};

/**
* | output |
* | --- |
* | "The open ledger" |
*
* @param {Mk_Sec_Pg_Ledger_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_overline = /** @type {((inputs?: Mk_Sec_Pg_Ledger_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_overline(inputs)
	return en_mk_sec_pg_ledger_overline(inputs)
});